import { createTheme } from '@mui/material/styles';
import green from '@mui/material/colors/green';

let theme = createTheme({
  palette: {
    primary: {
      dark: '#012b5b',
      light: '#32A8E0',
      main: '#125ED0'
    },
    secondary: green,
    text: {
      primary: '#333333'
    }
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    fontSize: 14,
    h1: {
      fontSize: 24,
      fontWeight: 'bold'
    },
    h2: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    h3: {
      fontSize: 16,
      fontWeight: 'bold'
    },
    h4: {
      fontSize: 14
    },
    h5: {
      fontSize: 12
    },
    h6: {
      fontSize: 11
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 'bold'
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 'bold'
    },
    body1: {
      fontSize: 14,
      fontWeight: 'normal'
    },
    body2: {
      fontSize: 16,
      fontWeight: 'normal'
    },
    button: {
      fontSize: 13,
      fontWeight: 'bold'
    },
    caption: {
      fontSize: 12,
      fontWeight: 'normal'
    },
    overline: {
      fontSize: 12,
      fontWeight: 'normal'
    }
  }
});

theme = createTheme(theme, {
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black'
          },
          '& > fieldset > legend': {
            fontSize: '16px'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontSize: '18px'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '18px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '19px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            fontSize: '18px'
          },
          '& .Mui-disabled': {
            fontSize: '18px'
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h1: theme.palette.primary.dark
      }
    },
    MuiGrid: {
      defaultProps: {
        spacing: 2
      }
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        size: 'small'
      },

      styleOverrides: {
        contained: {
          '& svg': { fontSize: '16px !important', marginBottom: '2px' },
          padding: '4px 10px',
          fontSize: '0.71125rem',
          fontWeight: 500,
          backgroundColor: theme.palette.primary.main,
          '&.primaryMain': { backgroundColor: theme.palette.primary.main },
          '&.primaryLight': { backgroundColor: theme.palette.primary.light },
          '&.primaryDark': { backgroundColor: theme.palette.primary.dark },
          '&.secondary': { backgroundColor: theme.palette.secondary.main },
          color: 'white',
          '&:disabled': {
            backgroundColor: theme.palette.action.disabled
          },
          '&.danger': { backgroundColor: theme.palette.error.dark },
          '&:hover': {
            boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.primary.main,
            color: theme.palette.primary.main,
            backgroundColor: 'white',
            '&.primaryMain': {
              boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.primary.main,
              color: theme.palette.primary.main
            },
            '&.primaryLight': {
              boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.primary.light,
              color: theme.palette.primary.light
            },
            '&.primaryDark': {
              boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.primary.dark,
              color: theme.palette.primary.dark
            },
            '&.secondary': {
              boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.secondary.main,
              boxSizing: 'border-box',
              color: theme.palette.secondary.main
            },
            '&.danger': {
              boxShadow: 'inset 0px 0px 0px 1px ' + theme.palette.error.dark,
              boxSizing: 'border-box',
              color: theme.palette.error.dark
            }
          },
          boxShadow: 'none',
          palette: {
            primary: theme.palette.primary.main,
            secondary: 'red'
          }
        },
        root: {
          boxShadow: 'none'
        }
      }
    },

    MuiIconButton: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          '&:hover': {
            '&.primaryMain': { color: theme.palette.primary.main },
            '&.primaryLight': { color: theme.palette.primary.light },
            '&.primaryDark': { color: theme.palette.primary.dark },
            '&.secondary': { color: theme.palette.secondary.main }
          }
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: 'pointer'
        }
      }
    },
    MuiInputBase: {
      defaultProps: {
        variant: 'outlined'
      },
      styleOverrides: {
        input: {
          '&.Mui-disabled': {
            color: 'black',
            '-webkit-text-fill-color': 'black'
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.CardButton': {
            borderWidth: 1,
            borderColor: theme.palette.action.disabled,
            borderStyle: 'solid',
            boxShadow: 'none',
            textAlign: 'center',
            '&-selected': {
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main
            },
            '& > .MuiCardActionArea-root': {
              '&:disabled': {
                color: theme.palette.action.disabled
              }
            }
          }
        }
      }
    }
  }
});

export { theme };
